export const SECTION_WIDGET_NAME = 'Section2';
